export default function isFunction(func) {
    return typeof func === 'function';
}
